import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ControlsOf, FormGroup } from '@ngneat/reactive-forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormBudget } from '../../../core/models/form-group-mapping.model';
import { FormType } from '../../../core/models/form.model';
import { Question } from '../../../core/models/question/question.model';
import { RendererFormsRepository } from '../../../core/repositories/renderer-forms.repository';

@UntilDestroy()
@Component({
  selector: 'lib-question-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BudgetComponent implements OnInit {
  @Input() questionForm: FormGroup<ControlsOf<FormBudget>>;
  @Input() repeaterGroupId: string;
  @Input() formBuilder: boolean;
  @Input() question: Question;

  formType: FormType;
  FormType = FormType;

  constructor(private rendererFormsRepository: RendererFormsRepository) {}

  ngOnInit(): void {
    this.formType = this.rendererFormsRepository.getActive()?.type;
  }
}
